import { useState } from 'react'
import { Paperclip } from 'lucide-react'
import { s3Service } from '@/services/s3Service'

/**
 * Selector del archivo de evaluación (SRH-309).
 *
 * Sube el archivo en cuanto se elige y le entrega la URL a quien lo use, como
 * el CV del alta manual: así el formulario o el modal solo cargan una URL y no
 * un archivo a medio subir.
 */
export const CampoDeEvaluacion = ({
  id,
  url,
  onCambio,
  deshabilitado = false,
}: {
  id: string
  url: string
  onCambio: (url: string) => void
  deshabilitado?: boolean
}) => {
  const [subiendo, setSubiendo] = useState(false)
  const [nombre, setNombre] = useState('')
  const [error, setError] = useState<string | null>(null)

  const subir = async (evento: React.ChangeEvent<HTMLInputElement>) => {
    const archivo = evento.target.files?.[0]
    if (!archivo) return

    const revision = s3Service.validateFile(archivo)
    if (!revision.valid) {
      setError(revision.error ?? 'El archivo no es válido')
      return
    }

    setError(null)
    setSubiendo(true)
    setNombre(archivo.name)
    try {
      const subida = await s3Service.uploadFile(archivo, 'evaluaciones')
      if (subida.success && subida.url) {
        onCambio(subida.url)
      } else {
        setError(subida.message || 'No se pudo subir el archivo')
        setNombre('')
      }
    } catch {
      setError('No se pudo subir el archivo. Intenta de nuevo.')
      setNombre('')
    } finally {
      setSubiendo(false)
    }
  }

  const bloqueado = subiendo || deshabilitado

  return (
    <div>
      <div className="flex items-center gap-3 flex-wrap">
        <label
          htmlFor={id}
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            bloqueado
              ? 'bg-gray-100 text-gray-400 cursor-default'
              : 'bg-[#EEF0FB] text-[#3D4B8F] hover:bg-[#E2E6F7] cursor-pointer'
          }`}
        >
          <Paperclip className="w-4 h-4" />
          {subiendo ? 'Subiendo…' : url ? 'Cambiar archivo' : 'Seleccionar archivo'}
        </label>
        <input
          id={id}
          type="file"
          accept=".pdf,.doc,.docx"
          disabled={bloqueado}
          onChange={(e) => void subir(e)}
          className="hidden"
        />
        <span className="text-sm text-gray-500">
          {nombre || (url ? 'Archivo cargado' : 'Sin archivo seleccionado')}
        </span>
      </div>
      {error ? (
        <p className="text-xs text-red-600 mt-1">{error}</p>
      ) : (
        <p className="text-xs text-gray-500 mt-1">PDF, DOC o DOCX.</p>
      )}
    </div>
  )
}
